module.exports = __webpack_public_path__ + "img/averageCop.da46354c.png";